/* tslint:disable */
/**
 * This file is autogenerated using @sharefiledev/solution-view-engine-tools.
 *
 * Run 'sve typegen <relative path to manifest file>'
 *
 * Types are generated according to specification in a file that conforms to the UI Manifest schema:
 * https://us-solutionviewengine.sharefiletest.io/ui-manifest-v2.json
 */
import type {
	PiletApi,
	PiralCustomExtensionSlotMap as ShellPiralCustomExtensionSlotMap,
} from '@sharefiledev/sharefile-appshell';
import type { BlockParams } from '@sharefiledev/solution-view-engine';

export interface ShellProps {
	piletApi: PiletApi;
}
/** Block parameters for urn:block:docgen:send-agreement-button */

export interface SendAgreementButtonBlockParams {
	context: {
		inputs?: {
			clientId?: string;
			documentTemplateRID?: string;
			projectRID?: string;
		};
	};
	flowRID: string;
	collectUserInput?: boolean;
	/**
	 * Localized String Values
	 */
	buttonText: {
		en?: string;
		es?: string;
		de?: string;
		fr?: string;
		it?: string;
		ja?: string;
		nl?: string;
		'pt-BR'?: string;
	};
	type?: 'default' | 'primary' | 'dashed' | 'link' | 'text';
	size?: 'small' | 'middle' | 'large';
	tourStep: {
		/**
		 * Localized String Values
		 */
		title: {
			en?: string;
			es?: string;
			de?: string;
			fr?: string;
			it?: string;
			ja?: string;
			nl?: string;
			'pt-BR'?: string;
		};
		/**
		 * Localized String Values
		 */
		description: {
			en?: string;
			es?: string;
			de?: string;
			fr?: string;
			it?: string;
			ja?: string;
			nl?: string;
			'pt-BR'?: string;
		};
		weight: number;
		style?: {
			width: string | number;
		};
		placement?:
			| 'left'
			| 'leftTop'
			| 'leftBottom'
			| 'right'
			| 'rightTop'
			| 'rightBottom'
			| 'top'
			| 'topLeft'
			| 'topRight'
			| 'bottom'
			| 'bottomLeft'
			| 'bottomRight'
			| 'center';
		analyticsId?: string;
	};
}
/** Zone parameters for urn:zone:docgen:send-agreement-extra-context-zone */

export interface SendAgreementExtraContextZoneZoneParams {
	modalWidth?: number;
}

export namespace BlockNames {
	export const SendAgreementButton = 'urn:block:docgen:send-agreement-button' as const;
	export type SendAgreementButton = 'urn:block:docgen:send-agreement-button';
}

export namespace ZoneTypes {
	export const SendAgreementExtraContextZone =
		'urn:zone:docgen:send-agreement-extra-context-zone' as const;
	export type SendAgreementExtraContextZone =
		'urn:zone:docgen:send-agreement-extra-context-zone';
}

export type SendAgreementButtonProps = ShellProps &
	BlockParams &
	SendAgreementButtonBlockParams;

declare module '@sharefiledev/sharefile-appshell' {
	interface PiralCustomExtensionSlotMap {
		['urn:block:docgen:send-agreement-button']: BlockParams &
			SendAgreementButtonBlockParams;
	}
}

declare module '@sharefiledev/solution-view-engine' {
	interface BlockCustomExtensionSlotMap extends ShellPiralCustomExtensionSlotMap {}

	interface PiletExtensionApi extends PiletApi {}

	interface ViewEngineCustomZoneParametersMap {
		['urn:zone:docgen:send-agreement-extra-context-zone']: SendAgreementExtraContextZoneZoneParams;
	}

	interface ViewEngineCustomZoneContractDataMap {
		['urn:zone:docgen:send-agreement-extra-context-zone']: never;
	}
}
